import React, { useState, useEffect, useRef } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Box,
  TextField,
  Button,
  useMediaQuery,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  Divider,
  makeStyles,
} from "@material-ui/core";
import { Link as RouterLink, useHistory, useLocation } from "react-router-dom";
import { moment } from "moment";
import { useTheme } from "@material-ui/core/styles";
import MenuIcon from "@material-ui/icons/Menu";
import AccountCircle from "@material-ui/icons/AccountCircle";
import RefreshIcon from "@material-ui/icons/Refresh";
import { useDispatch, useSelector } from "react-redux";
import {
  actions,
  getDataFromDashboard,
  getBranchWiseSale,
  updateLoginBegin,
} from "../../redux/user";
import ChangePwd from "../../Components/ChangePwd";
import DatePicker from "../../Components/DatePicker";
import CloseIcon from "@material-ui/icons/Close";
import StoreIcon from "@material-ui/icons/Store";
import StoreMallDirectoryIcon from "@material-ui/icons/StoreMallDirectory";
import AssessmentIcon from "@material-ui/icons/Assessment";

const useStyles = makeStyles((theme) => ({
  inputMarginDense: {
    textAlign: "center",
  },
  menuPaper: {
    marginTop: theme.spacing(1),
    top: "48px !important",
    boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
    "& .MuiMenuItem-root:hover": {
      backgroundColor: "#E6F7EF",
    },
  },
  card: {
    marginTop: theme.spacing(2),
  },
  headerShell: {
    position: "relative",
    zIndex: 10,
    backgroundColor: "#F8FAFC",
    borderRadius: "0 0 20px 20px",
    overflow: "hidden",
    boxShadow:
      "0 6px 18px rgba(8, 120, 79, 0.16), 0 2px 6px rgba(0,0,0,0.06)",
  },
  headerEdgeTop: {
    height: 4,
    background: "linear-gradient(90deg, #a7f3d0 0%, #d1fae5 50%, #a7f3d0 100%)",
    boxShadow: "inset 0 -1px 0 rgba(255,255,255,0.7)",
  },
  headerEdgeSecond: {
    height: 3,
    background: "linear-gradient(90deg, #34d399 0%, #6ee7b7 50%, #34d399 100%)",
    boxShadow: "inset 0 1px 0 rgba(255,255,255,0.35)",
  },
  appBar: {
    background: "linear-gradient(180deg, #08784F 0%, #076b47 48%, #065F46 100%)",
    boxShadow:
      "inset 0 1px 0 rgba(255,255,255,0.22), inset 0 -1px 0 rgba(0,0,0,0.12), 0 4px 14px rgba(6, 95, 70, 0.3)",
    borderBottom: "1px solid rgba(4, 70, 50, 0.35)",
    borderTop: "1px solid rgba(255,255,255,0.2)",
    position: "relative",
    overflow: "hidden",
    borderRadius: "0 0 20px 20px",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      height: 1,
      background: "rgba(255,255,255,0.35)",
      pointerEvents: "none",
    },
    "&::after": {
      content: '""',
      position: "absolute",
      top: 2,
      left: 0,
      right: 0,
      height: 1,
      background: "rgba(255,255,255,0.12)",
      pointerEvents: "none",
    },
  },
  toolbar: {
    minHeight: 60,
    paddingLeft: 10,
    paddingRight: 10,
    position: "relative",
    zIndex: 1,
    [theme.breakpoints.up("sm")]: {
      minHeight: 68,
      paddingLeft: 16,
      paddingRight: 16,
    },
  },
  headerIconBtn: {
    color: "#fff",
    backgroundColor: "rgba(255,255,255,0.16)",
    border: "1px solid rgba(255,255,255,0.28)",
    boxShadow: "0 2px 6px rgba(0,0,0,0.12), inset 0 1px 0 rgba(255,255,255,0.25)",
    marginLeft: 4,
    width: 38,
    height: 38,
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.28)",
    },
  },
  headerTitle: {
    color: "#fff",
    fontWeight: 800,
    letterSpacing: "0.01em",
    lineHeight: 1.2,
    textShadow: "0 1px 3px rgba(0,0,0,0.2)",
  },
  branchName: {
    marginTop: 2,
    color: "rgba(255,255,255,0.92)",
    fontSize: "0.78rem",
    fontWeight: 400,
    maxWidth: "100%",
    lineHeight: 1.3,
    background: "none",
    border: "none",
    boxShadow: "none",
    padding: 0,
  },
  desktopDates: {
    display: "flex",
    gap: 12,
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
    alignItems: "center",
    backgroundColor: "rgba(0,0,0,0.16)",
    borderRadius: 12,
    padding: "6px 12px",
    boxShadow:
      "inset 0 2px 5px rgba(0,0,0,0.22), inset 0 -1px 0 rgba(255,255,255,0.12)",
    border: "1px solid rgba(255,255,255,0.15)",
  },
  dateFieldEmbedded: {
    display: "flex",
    alignItems: "center",
    gap: 4,
    backgroundColor: "transparent",
  },
  dateLabel: {
    fontSize: "0.75rem",
    fontWeight: 600,
    color: "#273449",
    background: "none",
    flexShrink: 0,
  },
  dateLabelLight: {
    fontSize: "0.8rem",
    fontWeight: 600,
    color: "#fff",
    background: "none",
    flexShrink: 0,
  },
  mobileDateBar: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "nowrap",
    gap: 8,
    padding: "8px 12px",
    margin: "8px 10px 6px",
    backgroundColor: "#FFFFFF",
    border: "1px solid #E2E8F0",
    borderRadius: 16,
    boxShadow: "0 1px 4px rgba(39, 52, 73, 0.06)",
    position: "relative",
    zIndex: 2,
  },
  mobileDateBox: {
    display: "flex",
    alignItems: "center",
    gap: 4,
    flex: 1,
    minWidth: 0,
    padding: "6px 10px",
    borderRadius: 12,
    backgroundColor: "#F8FAFC",
    boxShadow: "none",
    border: "1px solid #E2E8F0",
  },


  drawerPaper: {
    width: 260,
    backgroundColor: "#F8FAFC",
    borderRight: "none",
    boxShadow: "4px 0 20px rgba(6, 95, 70, 0.1)",
  },
  drawerBrand: {
    backgroundColor: "#E6F7EF",
    padding: "16px 14px 18px",
    color: "#065F46",
    position: "relative",
    borderBottom: "1px solid #E2E8F0",
  },
  drawerBrandTop: {
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: 8,
  },
  closeBtn: {
    color: "#666",
    padding: 4,
    backgroundColor: "rgba(0,0,0,0.05)",
    "&:hover": {
      backgroundColor: "rgba(0,0,0,0.1)",
    },
  },
  drawerBrandLabel: {
    fontSize: "0.68rem",
    letterSpacing: "0.1em",
    textTransform: "uppercase",
    color: "#64748B",
    fontWeight: 500,
    marginBottom: 4,
  },
  drawerTitle: {
    fontSize: "1.2rem",
    fontWeight: 700,
    lineHeight: 1.25,
    color: "#065F46",
  },
  drawerBody: {
    padding: "14px 10px 20px",
  },
  sectionBlock: {
    marginBottom: 16,
  },
  sectionChip: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    backgroundColor: "#E6F7EF",
    border: "none",
    borderRadius: 8,
    padding: "8px 12px",
    marginBottom: 8,
    width: "100%",
    boxSizing: "border-box",
    boxShadow: "none",
  },
  sectionChipText: {
    fontSize: "0.72rem",
    fontWeight: 700,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "#065F46",
  },
  menuList: {
    padding: 0,
    backgroundColor: "#FFFFFF",
    borderRadius: 10,
    overflow: "hidden",
    boxShadow: "0 1px 4px rgba(39, 52, 73, 0.04)",
    border: "1px solid #E2E8F0",
  },
  listItem: {
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 12,
    paddingRight: 12,
    borderLeft: "3px solid transparent",
    transition: "background-color 0.15s ease",
    "&:hover": {
      backgroundColor: "#F0FDF4",
    },
  },
  listItemIcon: {
    minWidth: 32,
    color: "#94A3B8",
  },
  listItemText: {
    fontSize: "0.8rem",
    color: "#273449",
    fontWeight: 500,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  listDivider: {
    marginLeft: 44,
    backgroundColor: "#E2E8F0",
  },
}));

// ============================================================
// ✅ iOS-SAFE DATE HELPERS — defined OUTSIDE component
// iOS Safari cannot parse "2024-03-07" with new Date()
// Fix: split string into parts → new Date(year, month-1, day)
// ============================================================

const parseDateSafe = (date) => {
  if (date instanceof Date) {
    console.log("[parseDateSafe] Already Date object:", date.toString());
    return date;
  }
  if (typeof date === "string" && date.includes("-")) {
    const parts = date.split("-").map(Number);
    const result = new Date(parts[0], parts[1] - 1, parts[2]);
    console.log(
      "[parseDateSafe] String input:", date,
      "→ Parsed:", result.toString(),
      "| getDate():", result.getDate(),
      "| isValid:", !isNaN(result.getTime())
    );
    return result;
  }
  const fallback = new Date(date);
  console.log("[parseDateSafe] Fallback:", date, "→", fallback.toString(), "| isValid:", !isNaN(fallback.getTime()));
  return fallback;
};

const addOneDay = (dateStr) => {
  const original = parseDateSafe(dateStr);
  const d = new Date(original); // clone date
  d.setDate(d.getDate() + 1);
  return d;
};

const formatDate = (date, isFromDate = true) => {
  const d = date instanceof Date ? date : parseDateSafe(date);
  const dayStr = `${d.getDate()}`.padStart(2, "0");
  const monthStr = `${d.getMonth() + 1}`.padStart(2, "0");
  const yearStr = d.getFullYear();
  const time = isFromDate ? "06:00:00 AM" : "05:59:59 AM";
  const result = `${monthStr}-${dayStr}-${yearStr} ${time}`;
  console.log(
    "[formatDate] Input:", typeof date === "object" ? date.toString() : date,
    "| isFromDate:", isFromDate,
    "→ Output:", result
  );
  return result;
};

// ============================================================

const Header = ({ data }) => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const [anchorEl, setAnchorEl] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);

  // Log todayISO on every render to confirm it's valid
  const todayISO = new Date().toISOString().split("T")[0];
  console.log("[Header] todayISO on render:", todayISO);

  const [fromDate, setFromDate] = useState(todayISO);
  const [toDate, setToDate] = useState(todayISO);
  const [dateError, setDateError] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 600);
  const [open, setOpen] = useState(false);
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);
  const [selectedBranchName, setSelectedBranchName] = useState("");
  const [selectedBranchCode, setSelectedBranchCode] = useState(null);

  const theme = useTheme();
  const isAvgSaleReport =
    location.pathname === "/dashboard/avg-sale-report";

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 600);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const dispatch = useDispatch();
  const userId = useSelector((state) => state.user.loggedInUserId);
  const branchCode = useSelector((state) => state.user.branchCode);

  const handleChangePassword = (
    password,
    confirmPassword,
    setPasswordError,
    setConfirmPasswordError,
    setShowAlert,
  ) => {
    if (!password || !confirmPassword) {
      setPasswordError("Password fields cannot be empty");
      setConfirmPasswordError("Password fields cannot be empty");
      return;
    }
    if (password !== confirmPassword) {
      setPasswordError("Passwords do not match");
      setConfirmPasswordError("Passwords do not match");
      return;
    }
    if (!userId) {
      setPasswordError("User ID is missing");
      return;
    }
    const payload = { userId, Pwd: password };
    dispatch(actions.updatePasswordBegin(payload));
    setShowAlert(true);
    setTimeout(() => setShowAlert(false), 3000);
    setOpen(false);
  };

  const handleMenu = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const handleDrawerToggle = () => setMobileOpen(!mobileOpen);

  const validateDates = () => {
    setDateError("");
    if (!fromDate || !toDate) {
      setDateError("Please select both dates");
      return false;
    }
    const startDate = parseDateSafe(fromDate); // ✅ iOS safe
    const endDate = parseDateSafe(toDate);     // ✅ iOS safe
    console.log("[validateDates] startDate:", startDate.toString(), "| endDate:", endDate.toString());
    if (startDate > endDate) {
      setDateError("To Date must be after From Date");
      return false;
    }
    return true;
  };

  const fetchAvgSaleReport = () => {
    if (!validateDates() || !userId) return;
    // Same date format as successful GetDataForDashboard API
    const formattedFromDate = formatDate(fromDate, true);
    const formattedToDate = formatDate(addOneDay(toDate), false);
    dispatch(
      getBranchWiseSale(formattedFromDate, formattedToDate, userId),
    );
  };

  const handleRefresh = () => {
    console.log("[handleRefresh] fromDate:", fromDate, "| toDate:", toDate, "| userId:", userId);
    if (isAvgSaleReport) {
      fetchAvgSaleReport();
      return;
    }
    const sortedBranches = compInfo
      .slice()
      .sort((a, b) => a.branchCode - b.branchCode);
    const branchCodeToUse =
      selectedBranchCode || (sortedBranches[0] && sortedBranches[0].branchCode);
    const formattedFromDate = formatDate(fromDate, true);
    const formattedToDate = formatDate(addOneDay(toDate), false); // ✅ iOS safe
    console.log("[handleRefresh] Sending to API → fromDate:", formattedFromDate, "toDate:", formattedToDate);
    dispatch(
      getDataFromDashboard(
        formattedFromDate,
        formattedToDate,
        userId,
        branchCodeToUse,
      ),
    );
    console.log("Refresh clicked");
  };

  const handleVisibilityChange = () => {
    if (document.visibilityState === "visible") {
      const currentDate = new Date().toISOString().split("T")[0];
      console.log("[visibilityChange] Resetting to:", currentDate);
      setFromDate(currentDate);
      setToDate(currentDate);
    }
  };

  useEffect(() => {
    document.addEventListener("visibilitychange", handleVisibilityChange);
    const interval = setInterval(() => {
      if (fromDate && toDate) {
        handleRefresh();
      }
      console.log("[Interval] Triggered - 5 min");
    }, 300000);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      clearInterval(interval);
    };
  }, [fromDate, toDate]);

  useEffect(() => {
    console.log("[useEffect dates/mobile] isMobile:", isMobile, "| fromDate:", fromDate, "| toDate:", toDate, "| userId:", userId, "| branchCode:", branchCode);
    if (!validateDates()) return;

    if (isAvgSaleReport) {
      fetchAvgSaleReport();
      // Keep dashboard fetch for branch list in sidebar when data isn't loaded yet
      if (!Array.isArray(data?.companyInfo) || data.companyInfo.length === 0) {
        const formattedFromDate = formatDate(fromDate, true);
        const formattedToDate = formatDate(addOneDay(toDate), false);
        dispatch(
          getDataFromDashboard(
            formattedFromDate,
            formattedToDate,
            userId,
            selectedBranchCode || branchCode,
          ),
        );
      }
      return;
    }

    const formattedFromDate = formatDate(fromDate, true);
    const formattedToDate = formatDate(addOneDay(toDate), false); // ✅ iOS safe
    console.log("[useEffect] API params → fromDate:", formattedFromDate, "| toDate:", formattedToDate);
    dispatch(
      getDataFromDashboard(
        formattedFromDate,
        formattedToDate,
        userId,
        selectedBranchCode || branchCode,
      ),
    );
  }, [isMobile, fromDate, toDate, dispatch, isAvgSaleReport]);

  const handleBranchClick = (branchCode, branchName) => {
    console.log("[handleBranchClick] branch:", branchCode, "| fromDate:", fromDate, "| toDate:", toDate);
    const formattedFromDate = formatDate(fromDate, true);
    const formattedToDate = formatDate(addOneDay(toDate), false); // ✅ iOS safe
    dispatch(
      getDataFromDashboard(
        formattedFromDate,
        formattedToDate,
        userId,
        branchCode,
      ),
    );
    setSelectedBranchCode(branchCode);
    setSelectedBranchName(branchName);
    setMobileOpen(false);
    if (isAvgSaleReport) {
      history.push("/dashboard");
    }
    console.log("Branch clicked:", branchCode, branchName);
  };

  const handleAvgSaleReportClick = () => {
    setMobileOpen(false);
    history.push("/dashboard/avg-sale-report");
    fetchAvgSaleReport();
  };

  const compInfo = Array.isArray(data?.companyInfo) ? data.companyInfo : [];

  useEffect(() => {
    if (!initialDataLoaded && compInfo.length > 0) {
      console.log("[initialDataLoaded useEffect] fromDate:", fromDate, "| toDate:", toDate);
      const sortedBranches = compInfo
        .slice()
        .sort((a, b) => a.branchCode - b.branchCode);
      const initialBranch = sortedBranches[0];
      if (initialBranch) {
        setSelectedBranchName(initialBranch.branchName);
        setSelectedBranchCode(initialBranch.branchCode);
        const formattedFromDate = formatDate(fromDate, true);
        const formattedToDate = formatDate(addOneDay(toDate), false); // ✅ iOS safe
        console.log("[initialDataLoaded] API params → fromDate:", formattedFromDate, "| toDate:", formattedToDate, "| branch:", initialBranch.branchCode);
        dispatch(
          getDataFromDashboard(
            formattedFromDate,
            formattedToDate,
            userId,
            initialBranch.branchCode,
          ),
        );
        console.log("Initial data fetched for branch:", initialBranch.branchCode);
      }
      setInitialDataLoaded(true);
    }
  }, [initialDataLoaded, compInfo, fromDate, toDate, dispatch, userId]);

  return (
    <>
      <Box className={classes.headerShell}>
        <Box className={classes.headerEdgeTop} />
        <Box className={classes.headerEdgeSecond} />
        <AppBar position="static" elevation={0} className={classes.appBar}>
          <Toolbar className={classes.toolbar}>
          {isMobile && (
            <IconButton
              edge="start"
              onClick={handleDrawerToggle}
              className={classes.headerIconBtn}
              style={{ marginLeft: 0, marginRight: 6 }}
            >
              <MenuIcon fontSize="small" />
            </IconButton>
          )}
          <Box style={{ flexGrow: 1, minWidth: 0, paddingRight: 8 }}>
            <Typography
              variant="h6"
              component="div"
              noWrap
              className={classes.headerTitle}
              style={{
                fontSize: isMobile ? "1.05rem" : "1.2rem",
              }}
            >
              {compInfo?.length > 0 && compInfo[0].compName}
            </Typography>
            {selectedBranchName ? (
              <Typography component="div" noWrap className={classes.branchName}>
                {selectedBranchName}
              </Typography>
            ) : null}
          </Box>

          {!isMobile && (
            <Box className={classes.desktopDates}>
              <Box className={classes.dateFieldEmbedded}>
                <Typography className={classes.dateLabelLight}>
                  From:
                </Typography>
                <DatePicker
                  color="#ffffff"
                  setValue={setFromDate}
                  value={fromDate}
                  compact
                />
              </Box>
              <Box className={classes.dateFieldEmbedded}>
                <Typography className={classes.dateLabelLight}>
                  To:
                </Typography>
                <DatePicker
                  color="#ffffff"
                  setValue={setToDate}
                  value={toDate}
                  compact
                />
              </Box>
              {dateError && (
                <Typography style={{ color: "#ffffff", fontSize: "0.75rem" }}>
                  {dateError}
                </Typography>
              )}
            </Box>
          )}

          <IconButton
            size="small"
            onClick={handleRefresh}
            className={classes.headerIconBtn}
          >
            <RefreshIcon fontSize="small" />
          </IconButton>

          <IconButton
            size="small"
            onClick={handleMenu}
            className={classes.headerIconBtn}
          >
            <AccountCircle />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            classes={{ paper: classes.menuPaper }}
          >
            <MenuItem onClick={() => setOpen(true)}>Change Password</MenuItem>
            <ChangePwd
              open={open}
              handleClose={() => setOpen(false)}
              handleChangePassword={handleChangePassword}
              handleCloseMenu={handleClose}
            />
            <Divider style={{ margin: "5px 0" }} />
            <MenuItem
              component={RouterLink}
              to="/"
              onClick={() => {
                const payload = { userId: userId, isLogin: false };
                dispatch(updateLoginBegin(payload));
                dispatch(actions.logOut());
                handleClose();
              }}
            >
              Logout
            </MenuItem>
          </Menu>
        </Toolbar>
        </AppBar>
      </Box>

      <Drawer
        anchor="left"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        classes={{ paper: classes.drawerPaper }}
      >
        <Box className={classes.drawerBrand}>
          <Box className={classes.drawerBrandTop}>
            <IconButton
              className={classes.closeBtn}
              onClick={handleDrawerToggle}
              size="small"
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
          <Typography className={classes.drawerBrandLabel}>
            Dashboard
          </Typography>
          <Typography className={classes.drawerTitle}>
            {compInfo?.length > 0 && compInfo[0].compName}
          </Typography>
        </Box>

        <Box className={classes.drawerBody}>
          <Box className={classes.sectionBlock}>
            <Box className={classes.sectionChip}>
              <StoreMallDirectoryIcon style={{ fontSize: 14, color: "#065F46" }} />
              <Typography className={classes.sectionChipText}>
                Branches
              </Typography>
            </Box>
            <List className={classes.menuList}>
              {[
                ...(compInfo?.length > 1 ? ["All"] : []),
                ...compInfo
                  .slice()
                  ?.sort((a, b) => a.branchCode - b.branchCode)
                  .map((item) => item.branchName),
              ].map((menuItem, index, array) => {
                const itemCode =
                  menuItem === "All"
                    ? 0
                    : compInfo.find((branch) => branch.branchName === menuItem)
                        ?.branchCode;

                return (
                  <React.Fragment key={index}>
                    <ListItem
                      className={classes.listItem}
                      button
                      onClick={() =>
                        handleBranchClick(
                          itemCode,
                          menuItem === "All"
                            ? "All Branches"
                            : compInfo.find(
                                (branch) => branch.branchName === menuItem,
                              )?.branchName,
                        )
                      }
                    >
                      <ListItemIcon className={classes.listItemIcon}>
                        <StoreIcon style={{ fontSize: 18 }} />
                      </ListItemIcon>
                      <Typography className={classes.listItemText}>
                        {menuItem}
                      </Typography>
                    </ListItem>
                    {index < array.length - 1 && (
                      <Divider className={classes.listDivider} />
                    )}
                  </React.Fragment>
                );
              })}
            </List>
          </Box>

          <Box className={classes.sectionBlock}>
            <Box className={classes.sectionChip}>
              <AssessmentIcon style={{ fontSize: 14, color: "#065F46" }} />
              <Typography className={classes.sectionChipText}>
                Reports
              </Typography>
            </Box>
            <List className={classes.menuList}>
              <ListItem
                className={classes.listItem}
                button
                onClick={handleAvgSaleReportClick}
              >
                <ListItemIcon className={classes.listItemIcon}>
                  <AssessmentIcon style={{ fontSize: 18 }} />
                </ListItemIcon>
                <Typography className={classes.listItemText}>
                  Average Sale Report
                </Typography>
              </ListItem>
            </List>
          </Box>
        </Box>
      </Drawer>

      {isMobile && (
        <Box className={classes.mobileDateBar}>
          <Box className={classes.mobileDateBox}>
            <Typography className={classes.dateLabel}>From</Typography>
            <DatePicker setValue={setFromDate} value={fromDate} compact />
          </Box>
          <Box className={classes.mobileDateBox}>
            <Typography className={classes.dateLabel}>To</Typography>
            <DatePicker setValue={setToDate} value={toDate} compact />
          </Box>
          {dateError && (
            <Typography
              style={{
                color: "#d32f2f",
                fontSize: "0.7rem",
                position: "absolute",
                bottom: 2,
                left: 0,
                right: 0,
                textAlign: "center",
              }}
            >
              {dateError}
            </Typography>
          )}
        </Box>
      )}
    </>
  );
};

export default Header;